import React from 'react';
import classNames from 'classnames';

type MssIconProps = {
  size?: number;
  icon: any;
  className?: string;
};

export const MssIcon = ({
  size = 18,
  icon: Icon,
  className,
  ...rest
}: MssIconProps) => {
  return (
    <Icon
      size={size}
      className={classNames(className)}
      style={{
        height: `${size}px`,
        width: `${size}px`,
      }}
      {...rest}
    />
  );
};

export default MssIcon;
